module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2023-10-22 at 18.56.10_1e66070e.4a6c3190.jpg";